<template>
  <div class="download-list">
    <ul v-if="showFiles.length > 0">
      <li v-for="(file, index) in showFiles" :key="index">
        <span class="title" :title="file.fileName">{{file.fileName}}</span>
        <span class="size" :title="file.size" v-if="file.size">{{file.size}}</span>
        <a
          class="go-download"
          :href="`/artemis-portal/artemis/service/rs/v3/download/file/downloadFile/${file.fileId}`"
        >
          <i class="h-icon-download"></i>
        </a>
      </li>
      <li v-if="files.length > 3" @click="moreToggle" class="toggle-btn">
        <el-button class="more-btn" type="primary">{{moreText}}</el-button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    files: { type: Array, default: () => [] },
    itemId: { type: Number }
  },
  computed: {
    showFiles() {
      return JSON.parse(JSON.stringify(this.files))
    }
  },
  data() {
    return {
      hiddenFiles: [],
      moreText: this.$t("download.showMore")
    };
  },
  created() {
    if (this.showFiles.length > 3) {
      this.hiddenFiles = this.showFiles.splice(3)
    }
  },
  methods: {
    moreToggle() {
      this.moreText = this.hiddenFiles.length
        ? this.$t("download.hideMore")
        : this.$t("download.showMore")

      if (this.hiddenFiles.length) {
        this.showFiles.push(...this.hiddenFiles)
        this.hiddenFiles.length = 0;
      } else {
        this.hiddenFiles = this.showFiles.splice(3)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.download-list {
  li {
    display: flex;
    justify-content: center;
    align-items: center;
    &.toggle-btn {
      margin-top: 15px;
    }
  }
  .title {
    width: 64%;
    white-space: nowrap;
    float: left;
    overflow: hidden;
    line-height: 20px;
  }
  .size {
    float: left;
    padding-right: 15px;
    width: 28%;
    text-align: right;
  }
  .go-download {
    display: inline-block;
    width: 8%;
    height: 24px;
    i {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.7);
    }
  }
  .more-btn {
    width: 100%;
    max-width: 237px;
  }
}
</style>
